import React, { useState, useEffect } from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
// import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ToastContainer, toast } from "react-toastify";

import { post } from "../network/api";

const PaymentForm = ({ price, handleSuccessCallback, handleErrorCallback }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    setStripePromise(
      loadStripe(
        //"pk_live_51Q2rVDJz9JwGV0Xq8lgBvf523q3NgGyrwtHC7eQS4sdORvElh75ach3XjS4gdYJu2atM7uRFNSsc1FVKaHk9GT5700AGdst1lx"
         "pk_test_51Q2rVDJz9JwGV0XqotlFKMayu2rQe47Plw3BAQLXQTbKEIIOkKsu7vAQQfihk3nlkG7vmdOnRALABwjiKvR4ogVU00pdA0xY6q"

      )
    );
  }, []);

  useEffect(() => {
    console.log(price);
    post("customer/create-payment-intent", {
      price: price ?? 100,
    }).then(async (data) => {
      setClientSecret(data);
    });
  }, []);

  return (
    <>
      {/* <h1>React Stripe and the Payment Element</h1> */}
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm
            handleErrorCallback={handleErrorCallback}
            handleSuccessCallback={handleSuccessCallback}
          />
        </Elements>
      )}
    </>
  );
};

export default PaymentForm;

function CheckoutForm({ handleSuccessCallback, handleErrorCallback }) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    // const { error, paymentMethod } = await stripe.createPaymentMethod({
    //   type: 'card',
    //   card: elements.getElement(CardElement),
    // });
    const { paymentIntent, error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/completion`,
        // redirect: "if_required", // Avoid automatic redirection
      },
      redirect: "if_required",
    });
    if (paymentIntent) {
      // handle payment back
      handleSuccessCallback(paymentIntent);
    } else if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occured. ");
        handleErrorCallback(error);
      }
    } else {
      console.log(paymentIntent, "Console log");
      console.log(error);
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button disabled={isProcessing || !stripe || !elements} id="submit">
        <span id="button-text">
          {isProcessing ? "Processing ... " : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
